/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function ContentCategoriesVideoComponentRolesPanelComponent(this: JS5Object, _: JS5Object, $routeParams: JS5Object,
                                                            uiGridConstants: JS5Object, $timeout: JS5Function) {
    this.$onInit = () => {
        setupData();
    };
    this.$onChanges = () => {
        setupData();
    };
    const setupData = () => {
        _.set(this, 'gridOptions.data', _.chain(_.get(this, 'editData.contentCategoryRoles')).partition((contentCategoryRole: JS5Object) => {
            return contentCategoryRole.name === 'Main Video'
        }).flatten().value());

        if ($routeParams.contentCategoryId === '-1') {
            addMainVideoRole();
        }
    };
    const addMainVideoRole = () => {
        if (_.isNil(_.get(this, 'editData.contentCategoryObject.videoRoles'))) {
            _.set(this, 'editData.contentCategoryObject.videoRoles', []);
        }
        let mainVideoRole = _.find(_.get(this, 'editData.contentCategoryRoles'), {name: 'Main Video'});
        if (!_.isNil(mainVideoRole)) {
            _.get(this, 'editData.contentCategoryObject.videoRoles').push({role: mainVideoRole});
        }

    };

    this.processGridFilter = (renderableRows: JS5Object) => {
        renderableRows.forEach((row: JS5Object) => {
            if (_.find(_.get(this, 'editData.contentCategoryObject.videoRoles'), (videoRole: JS5Object) => {
                    return videoRole.role.name === row.entity.name;
                })) {
                row.setSelected(true);
            } else {
                row.setSelected(false);
            }
        });
        return renderableRows;
    };

    this.gridRowSelectionChangedHandler = (row: JS5Object) => {
        if (row.entity.name !== 'Main Video') {
            if (_.isNil(_.get(this, 'editData.contentCategoryObject.videoRoles'))) {
                _.set(this, 'editData.contentCategoryObject.videoRoles', []);
            }
            let videoRoles = _.get(this, 'editData.contentCategoryObject.videoRoles');

            let existingVideoComponentRole = _.find(videoRoles, (videoRole: JS5Object) => {
                return videoRole.role.id === row.entity.id;
            });
            if (_.isNil(existingVideoComponentRole)) {
                videoRoles.push({
                    role: row.entity
                });
            } else if (_.has(existingVideoComponentRole, 'id')) {
                row.setSelected(true);
            } else {
                _.remove(videoRoles, (videoRole: JS5Object) => {
                    return videoRole.role.id === row.entity.id;
                });
            }
            this.editorForm.$setDirty();
            _.set(this, 'editData.contentCategoryObject.videoRoles', _.sortBy(videoRoles, (videoRole) => {
                return videoRole.role.name
            }));
            _.set(this, 'editData.contentCategoryObject.videoRoles', _.chain(_.get(this, 'editData.contentCategoryObject.videoRoles')).partition((videoRole) => {
                return videoRole.role.name === 'Main Video'
            }).flatten().value());
        } else {
            row.setSelected(true);
        }

    };

    const columnDefinitions = [
        {	// Enabled checkbox column
            name: 'checkMarkRowHeaderCol',
            field: 'checkMark',
            width: 30,
            enableColumnMenu: false,
            enableSorting: false,
            enableColumnResizing: false,
            headerCellTemplate: '<div></div>',
            cellTemplate: 'components/visual/grid/check-mark-template.html'
        },
        {
            field: 'name',
            displayName: 'Name',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];

    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        rowHeight: 26,
        multiSelect: true,
        columnDefs: columnDefinitions,
        onRegisterApi: (gridApi: JS5Object) => {
            this.gridApi = gridApi;
            this.gridApi.grid.registerRowsProcessor(this.processGridFilter, 200);
            this.gridApi.selection.on.rowSelectionChanged(null, this.gridRowSelectionChangedHandler);
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };
}


angular.module('prism-ui.content').component('contentCategoriesVideoComponentRolesPanel', {
    templateUrl: 'meta/content/editor/components/view/categories/editor/components/contentCategoriesPropertiesView/videoComponentRoles/content-categories-video-component-roles-panel-template.html',
    controller: ContentCategoriesVideoComponentRolesPanelComponent,
    bindings: {
        editData: '<'
    }
});
